import { render } from "./BlockUserDetails.vue?vue&type=template&id=63015475&scoped=true"
import script from "./BlockUserDetails.vue?vue&type=script&lang=js"
export * from "./BlockUserDetails.vue?vue&type=script&lang=js"

import "./BlockUserDetails.vue?vue&type=style&index=0&id=63015475&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63015475"]])

export default __exports__